<template>
  <div class="right-content">
    <AvatarDropdown 
      :menu="showMenu" 
      :current-user="currentUser" 
      class="header-action"
    />
    <SelectLang v-if="showSelectLang" class="header-action" />
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown.vue'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    topMenu: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      showMenu: true,
      showSelectLang: false,
      currentUser: {}
    }
  },
  mounted() {
    const userDataStr = localStorage.getItem('userData')
    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr)
        this.currentUser = {
          name: userData.username || '用户'
        }
      } catch (e) {
        console.error('解析 userData 失败', e)
        this.currentUser = {
          name: '用户'
        }
      }
    } else {
      this.currentUser = {
        name: '用户'
      }
    }
  }
}
</script>

<style scoped>
.right-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-action {
  display: flex;
  align-items: center;
}
</style>
